export default __webpack_public_path__ + "static/media/center.95c7f1f5.png";